<template>
  <div class="fivth-blog">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="item in list.slice(0, 3)"
        :key="item.id"
        class="grid__item news-top"
      >
        <div class="news-top__content">
          <div class="news-top__category-desktop">
            {{ item.sub_category.name }}
          </div>
          <div class="flex-md flex-lg">
            <div class="news-top__img">
              <ImageContainer
                class="img"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
            </div>
            <div class="news-top__title">
              <div class="news-top__category">
                {{ item.sub_category.name }}
              </div>
              <h3 class="limited-text">{{ item.title }}</h3>
              <div class="news-top__brief ">
                {{ item.brief }}
              </div>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>

    <div class="circule-block">
      <div class="container">
        <router-link
          :to="
            $i18nRoute({
              name: 'NewsDetail',
              params: { slug: item.url }
            })
          "
          v-for="(item, index) in list.slice(0, 3)"
          :key="item.id"
          :class="`item-${index + 1}`"
        >
          <div>
            <div class="circule-block__title">
              <div class="circule-block__category">
                {{ item.sub_category.name }}
              </div>
              <h3 class="limited-text">{{ item.title }}</h3>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </router-link>

        <div class="images">
          <div class="center">
            <router-link
              :to="
                $i18nRoute({
                  name: 'NewsDetail',
                  params: { slug: list[0].url }
                })
              "
              class="left"
            >
              <svg
                @click="routePage(list[0])"
                viewBox="0 0 354 538"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <clipPath id="shape-1">
                  <path
                    d="M51.1907 537.296C18.7147 483.669 1.06467 422.378 0.0466737 359.692C-0.971326 297.006 14.6797 235.175 45.3987 180.522C76.1167 125.869 120.801 80.3557 174.88 48.6377C228.958 16.9197 290.492 0.1348 353.186 0L353.947 353.946L51.1907 537.296Z"
                    fill="#CA4E4E"
                  />
                </clipPath>
                <image
                  clip-path="url(#shape-1)"
                  :xlink:href="list[0].image.large"
                  x="0"
                  y="0"
                  width="100%"
                  height="100%"
                  preserveAspectRatio="xMidYMid slice"
                ></image>
              </svg>
            </router-link>
            <router-link
              :to="
                $i18nRoute({
                  name: 'NewsDetail',
                  params: { slug: list[1].url }
                })
              "
              class="right"
            >
              <svg
                viewBox="0 0 355 531"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <clipPath id="shape-2">
                  <path
                    d="M0 0.000821781C62.193 -0.133178 123.323 16.1226 177.235 47.1311C231.146 78.1395 275.935 122.807 307.092 176.633C338.248 230.459 354.672 291.544 354.709 353.738C354.746 415.931 338.394 477.036 307.301 530.899L0.761993 353.947L0 0.000821781Z"
                    fill="#4A43A0"
                  />
                </clipPath>
                <image
                  width="100%"
                  height="100%"
                  clip-path="url(#shape-2)"
                  :xlink:href="list[1].image.large"
                  x="0"
                  y="0"
                  preserveAspectRatio="xMidYMid slice"
                ></image>
              </svg>
            </router-link>
            <router-link
              :to="
                $i18nRoute({
                  name: 'NewsDetail',
                  params: { slug: list[2].url }
                })
              "
              class="bottom"
            >
              <svg
                viewBox="0 0 611 355"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <clipPath id="shape-3">
                  <path
                    d="M610.027 177.473C579.276 230.736 535.177 275.066 482.076 306.096C428.975 337.125 368.706 353.783 307.207 354.427C245.708 355.071 185.102 339.679 131.363 309.769C77.6245 279.858 32.6068 236.461 0.747009 183.854L303.5 0.5L610.027 177.473Z"
                    fill="#CA4EAF"
                  />
                </clipPath>
                <image
                  clip-path="url(#shape-3)"
                  :xlink:href="list[2].image.large"
                  x="0"
                  y="0"
                  width="100%"
                  height="100%"
                  preserveAspectRatio="xMinYMin slice"
                ></image>
              </svg>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="news-bottom">
      <transition-group name="bottom" appear>
        <template v-for="item in list.slice(3, 7)" :key="item.id">
          <router-link
            :to="
              $i18nRoute({
                name: 'NewsDetail',
                params: { slug: item.url }
              })
            "
            class="news"
          >
            <div class="news__category">
              {{ item.sub_category.category.name }}
            </div>
            <div class="news__container">
              <div class="news__img">
                <ImageContainer
                  :src="item.image.medium"
                  :thumb="item.image.thumbnail"
                  :alt="item.title"
                />
              </div>

              <div class="news__info">
                <h4 class="news__title limited-text" style="--snup: 3">
                  {{ item.title }}
                </h4>
                <div class="data-news">
                  <span class="day">{{ handleDate(item.pub_date) }},</span>
                  <span class="time">{{ handleTime(item.pub_date) }}</span>
                </div>
              </div>
            </div>
          </router-link>
        </template>
      </transition-group>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";
import { useRouter } from "vue-router";
import { useLanguage } from "@/utils/language";

export default {
  name: "FivthBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    const router = useRouter();
    const { i18n } = useLanguage();

    const routePage = slugPage => {
      console.log(slugPage.url);
      router.push({
        name: `${i18n.global.locale.value || i18n.global.locale}_NewsDetail`,
        params: { slug: slugPage.url }
      });
    };
    return {
      routePage,
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
$ofset-white-block: 2.85rem;
$bg-white: #f4fffb;
$text-on-bg: #121212;
$color-on-bg-data: #939393;
$green: #447562;

.flex-md {
  @media screen and (max-width: 992px) {
    display: flex;
    transform: translateX(-20px);
    // width: 80%;
  }
  @media screen and (max-width: 767px) {
    transform: translateX(0);
    width: 90%;
  }
}
.fivth-blog {
  width: 100%;
  @media screen and (max-width: 375px) {
    overflow: hidden;
    width: 100%;
  }
}
.grid {
  display: none;
  margin: 0 auto;
  // display: grid;
  // grid-template-columns: 1fr 1fr 1fr;
  // grid-template-areas: "item-1 item-2 item-3";
  position: relative;
  max-width: var(--main-wrapper-width);
  margin-bottom: 35px;
  @media screen and (max-width: 767px) {
    background-color: $bg-white;
    width: 100%;
    color: $text-on-bg;
    padding: 0 1rem;
  }

  @media screen and (max-width: 992px) {
    display: grid;

    grid-template-columns: 1fr;
    grid-template-areas: "item-1" "item-2" "item-3";
    max-width: 100%;
    margin-bottom: 0;
  }
  &__item:nth-child(1) {
    grid-area: item-1;
    @media screen and (max-width: 992px) {
      max-width: var(--main-wrapper-width);
      margin: 0 auto;
    }
    @media screen and (max-width: 767px) {
      max-width: 100%;
      margin: 0;
    }

    .news-top {
      &__content {
        width: 100%;
        .flex-md {
          transform: translateX(0);
        }
        @media screen and (max-width: 992px) {
          display: flex;
          flex-direction: row;
          align-items: flex-start;
        }
        @media screen and (max-width: 767px) {
          flex-direction: column;
          width: 100%;
        }
      }
      &__brief {
        display: none;
        @media screen and (max-width: 992px) {
          display: block;
          margin-top: 10px;
          font-family: Roboto;
          font-size: 16px;
          line-height: 145%;
        }
        @media screen and (max-width: 767px) {
          display: none;
        }
      }
      &__title {
        .limited-text {
          font-family: Roboto;
          font-weight: 500;
          font-size: 1.2em;
          line-height: 130%;
        }
        @media screen and (max-width: 992px) {
          position: relative;
          left: 0;
          text-align: left;
          padding: 0 1rem;
          .limited-text {
            font-style: normal;
            font-size: 18px;
            line-height: 25px;
            font-weight: 500;
          }
        }
        @media screen and (max-width: 767px) {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 0 10px;
          .limited-text {
            font-style: normal;
            font-size: 12px;
            line-height: 15px;
          }
        }
      }
      &__category {
        text-align: left;
        @media screen and (max-width: 992px) {
          display: none;
        }
      }
      &__img {
        @media screen and (max-width: 992px) {
          width: 305px;
          padding: 0;
          flex: 1 0 305px;
          position: relative;
          right: 0;
          height: 230px;
          max-width: 305px;
        }
        @media screen and (max-width: 767px) {
          max-width: 111px;
          height: 69px;
        }
      }
      &__category-desktop {
        // display: none;
        @media screen and (max-width: 992px) {
          padding: 0.2rem;
          display: block;
          margin: 0;
          position: absolute;
          top: 0;
          background: $green;
          z-index: 2;

          text-transform: uppercase;
          font-family: Open Sans;
          font-weight: 600;
          font-size: 13px;
          line-height: 18px;
        }
        @media screen and (max-width: 767px) {
          position: relative;
          background: transparent;
        }
      }
    }
  }
  &__item:nth-child(2) {
    grid-area: item-2;
    @media screen and (max-width: 992px) {
      color: $text-on-bg;
    }
    .news-top {
      @media screen and (max-width: 992px) {
        height: 100%;
      }

      &__content {
        width: 100%;
        height: 100%;
        @media screen and (max-width: 992px) {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin: 2rem auto 0;
          width: 90%;
          padding: 0rem 0.5rem;
          background-color: $bg-white;
          position: relative;
        }
        @media screen and (max-width: 767px) {
          width: 100%;
          margin: 0;
          padding: 0;
        }
      }
      &__category {
        @media screen and (max-width: 992px) {
          margin: 0;
          display: none;
        }
      }
      &__title {
        @media screen and (max-width: 992px) {
          padding: 0 10px;
        }
        .limited-text {
          line-height: 130%;
          font-weight: 500;
          @media screen and (max-width: 992px) {
            font-size: 18px;
            line-height: 25px;
            font-weight: 500;
          }
          @media screen and (max-width: 767px) {
            font-size: 12px;
            line-height: 15px;
          }
        }
        @media screen and (max-width: 767px) {
          width: 100%;
          justify-content: space-between;
          flex-direction: column;
          display: flex;
        }
      }
      &__img {
        @media screen and (max-width: 992px) {
          flex: 0 0 221px;
          position: relative;
          top: 0;
          left: 0;
          height: 135px;
          width: 221px;
        }
        @media screen and (max-width: 767px) {
          min-width: inherit;

          height: 69px;
          flex: 0 0 111px;
        }
      }
      &__brief {
        display: none;
      }
      &__category-desktop {
        // display: none;
        @media screen and (max-width: 992px) {
          display: block;
          color: $color-on-bg-data;
          background-color: transparent;
          position: relative;
          text-transform: uppercase;
          font-family: Open Sans;
          font-weight: 600;
          font-size: 13px;
          line-height: 18px;
        }
      }
    }
  }
  &__item:nth-child(3) {
    grid-area: item-3;
    width: 100%;
    @media screen and (max-width: 992px) {
      color: $text-on-bg;
      height: 100%;
      .flex-md {
        width: 100%;
      }
    }
    .news-top {
      &__content {
        @media screen and (max-width: 992px) {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          text-align: left;
          margin: 0;
          margin: 0 auto;
          width: 90%;
          background-color: $bg-white;
          padding: 1rem 0.5rem;
        }
        @media screen and (max-width: 767px) {
          width: 100%;
          padding: 0;
        }
      }
      &__title {
        padding: 0 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      &__brief {
        display: none;
      }
      &__category {
        display: none;
      }
      &__img {
        text-align: left;
        @media screen and (max-width: 992px) {
          flex: 1 0 221px;
          position: relative;
          top: 0;
          left: 0;
          height: 135px;
          max-width: 221px;
          transform: translateX(0);
          min-width: inherit;
        }
        @media screen and (max-width: 767px) {
          // min-width: 111px;
          width: 112px;
          height: 69px;
          flex: 1 0 111px;
        }
      }
      &__category-desktop {
        @media screen and (max-width: 992px) {
          display: block;
          color: $color-on-bg-data;
          background-color: transparent;
          position: relative;
          text-transform: uppercase;
          font-family: Open Sans;
          font-weight: 600;
          font-size: 13px;
          line-height: 18px;
        }
      }
    }
  }
}

.news-top {
  padding: 0 0.1rem;
  @media screen and (max-width: 992px) {
    padding: 0;
  }
  &__content {
    position: relative;
    @media screen and (max-width: 992px) {
      height: auto;
    }
  }
  &__img {
    height: 428px;
  }
  &__category-desktop {
    display: block;
    z-index: 1;
    position: absolute;
    top: 0;
    background-color: $green;
    padding: 0.1rem;
    @media screen and (max-width: 992px) {
      display: block;
    }
    @media screen and (max-width: 767px) {
      color: $color-on-bg-data;
      font-family: "Open Sans";
      font-size: 10px !important;
      line-height: 1.5;
    }
  }
  &__category {
    display: none;
  }
  &__title {
    position: absolute;
    bottom: 10px;
    // left: 50%;
    // transform: translateY(-50%);
    z-index: 1;
    text-align: center;
    width: 100%;
    @media screen and (max-width: 992px) {
      position: relative;
      text-align: left;
      bottom: 0;
    }
    .limited-text {
      font-family: Roboto;
      font-size: 19px;
      line-height: 130%;
      @media screen and (max-width: 992px) {
        font-size: 18px;
        line-height: 25px;
        font-weight: 500;
      }
      @media screen and (max-width: 767px) {
        font-size: 12px;
        line-height: 15px;
      }
    }
  }
}

.news-bottom {
  display: flex;
  background: $bg-white;
  flex-direction: row;
  height: 115px;
  width: 100%;
  @media screen and (max-width: 992px) {
    flex-direction: column;
    // margin: 0 $ofset-white-block;
    width: 90%;
    height: 100%;
    padding: 0 0.5rem;
    margin: 0 auto;
  }

  @media screen and (max-width: 767px) {
    margin: 0;
    width: 100%;
  }

  @media screen and (max-width: 375px) {
    margin: 0;
  }
}
.news {
  flex: 1 1 25%;
  max-height: 115px;
  margin-bottom: 10px;
  padding: 0 0rem 0 0.5rem;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 767px) {
    margin-bottom: 5px;
  }
  @media screen and (max-width: 992px) {
    max-height: 100%;
    &:nth-child(3) &__container {
      transform: translate(-25px);
    }
    &:nth-child(4) &__container {
      transform: translate(-25px);
    }
    &:nth-child(1) &__container {
      text-align: right;
      flex-direction: row-reverse;
      transform: translate(25px);
      .news__img {
        text-align: left;
      }
      @media screen and (max-width: 767px) {
        text-align: left;
        flex-direction: row;
      }
    }
    &:nth-child(2) &__container {
      text-align: right;
      flex-direction: row-reverse;
      transform: translate(25px);
      .news__img {
        text-align: left;
      }
      @media screen and (max-width: 767px) {
        text-align: left;
        flex-direction: row;
      }
    }
    &:nth-child(1) &__category {
      text-align: right;
      @media screen and (max-width: 767px) {
        text-align: left;
      }
    }
    &:nth-child(2) &__category {
      text-align: right;
      @media screen and (max-width: 767px) {
        text-align: left;
      }
    }
  }
  @media screen and (max-width: 767px) {
    &:nth-child(1) &__container {
      transform: translate(0px);
    }
    &:nth-child(2) &__container {
      transform: translate(0px);
    }
    &:nth-child(3) &__container {
      text-align: left;
      flex-direction: row;
      transform: translate(0);
    }
    &:nth-child(4) &__container {
      flex-direction: row;
      text-align: left;
      transform: translate(0);
      .news__img {
        text-align: left;
      }
    }
    &:nth-child(3) &__category {
      text-align: left;
    }
    &:nth-child(4) &__category {
      text-align: left;
    }
  }
  &__container {
    display: flex;
    gap: 0.4rem;
  }
  &__category {
    color: $text-on-bg;
    font-family: "Open Sans";
    font-size: 1em;
    line-height: 1.5;
    @media screen and (max-width: 992px) {
      text-transform: uppercase;
      font-size: 13px;
      line-height: 18px;
    }
    @media screen and (max-width: 767px) {
      font-style: normal;
      font-size: 10px;
      line-height: 14px;
    }
  }
  &__img {
    max-width: 112px;
    height: 84px;
    width: 100%;
    @media screen and (max-width: 992px) {
      min-width: 221px;
      height: 135px;
    }
    @media screen and (max-width: 767px) {
      min-width: 111px;
      height: 69px;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #121212;
    @media screen and (max-width: 992px) {
      width: 70%;
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
  }
  &__title {
    font-family: "Roboto";
    font-size: 1em;
    line-height: 1.2em;
    letter-spacing: 0.03em;
    font-weight: 500;
    @media screen and (max-width: 992px) {
      font-size: 18px;
      line-height: 25px;
      font-weight: 500;
    }
    @media screen and (max-width: 767px) {
      font-size: 12px;
      line-height: 15px;
    }
  }
  &__data {
    font-family: "Open Sans";
    line-height: 1.4rem;
    color: rgba(18, 18, 18, 0.7);
  }
}
.data-news {
  font-family: Open Sans;
  font-size: 0.88em;

  line-height: 19px;
  @media screen and (max-width: 992px) {
    font-size: 13px;
    line-height: 18px;
  }
  @media screen and (max-width: 767px) {
    font-family: Open Sans;
    font-size: 10px;
    line-height: 14px;
  }
}

.circule-block {
  margin-bottom: 2rem;
  @media screen and (max-width: 992px) {
    display: none;
  }
  &__category {
    color: $color-on-bg-data;
    font-family: Open Sans;
    font-size: 16px;
    line-height: 22px;
  }
  .data-news {
    margin-top: 0.5rem;
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 0.88em;

    line-height: 19px;
  }
  .limited-text {
    margin-top: 0.5rem;
    font-family: Roboto;
    font-style: normal;
    font-size: 1.2em;
    font-weight: 500;
    line-height: 130%;
  }
  .center {
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: 690px;
    width: 100%;
    margin: 0 auto;
  }
  .left > svg {
    position: absolute;
    right: 0;
    z-index: 1;
  }
  .left,
  .right,
  .bottom {
    widows: 100%;
    height: 344px;
    @media screen and (max-width: 1330px) {
      height: 26vw;
    }
  }
  .left {
    grid-column: span 1;
    position: relative;
    cursor: pointer;
  }
  .right {
    grid-column: span 1;
    position: relative;
    cursor: pointer;
    z-index: 1;
  }
  .right > svg {
    position: absolute;
  }
  .bottom {
    grid-column: span 2;
    position: relative;
    cursor: pointer;
    z-index: 2;
  }
  .bottom > svg {
    position: absolute;
    width: 86.5%;
    /* top: 345px; */
    // padding-top: 49.95%;
    left: 50%;
    transform: translateX(-49.5%);
  }
  .container {
    position: relative;
    display: grid;
    grid-template-columns: 1fr 0 clamp(10vw, 52vw, 700px) 1fr;
    grid-template-rows: 0 clamp(10vw, 52vw, 700px) auto;
  }
  .item-1 {
    grid-column: 1 / span 1;
    grid-row: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // max-width: 400px;
    max-width: 80%;
    justify-self: end;
    margin-right: 2rem;
    text-align: right;
  }
  .item-2 {
    grid-column: 4 / span 1;
    grid-row: 2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    // max-width: 400px;
    max-width: 80%;
    margin-left: 2rem;
  }
  .item-3 {
    grid-column: 2 / span 2;
    grid-row: 4;
    display: flex;
    flex-direction: column;
    // max-width: 400px;
    max-width: 80%;
    margin: 1rem auto;
    text-align: center;
  }
  .images {
    grid-column: 2 / span 2;
    grid-row: 1;
    width: 100%;
    /* position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                width: 100%; */
  }
}
</style>
